import { MOBILE } from '../../../constants/breakpoints';

export default theme => ({
    selectorContainer: {
        padding: '1rem',
        width: '100%',
        fontFamily: 'Inter, sans-serif',
        '& hr:nth-last-child(1)': {
            display: 'none'
        },
        position: 'relative'
    },
    loading: {
        display: 'flex',
        width: '100%',
        justifyContent: 'center',
        padding: '1rem'
    },
    selector: {
        '&:hover': {
            '& div:nth-child(1)': {
                borderRadius: '10px 0 0 0'
            },
            '& div:nth-last-child(2)': {
                borderRadius: '0 0 0 10px'
            }
        },
        [theme.breakpoints.up(MOBILE)]: {
            height: '50vh',
            overflowY: 'scroll'
        }
    },
    durationText: {
        fontFamily: 'Inter !important',
        fontWeight: '500 !important',
        fontSize: '16px !important',
        lineHeight: '24px !important',
        letterSpacing: '0% !important',
        color: '#727272 !important',
        margin: '0 !important',
        padding: '0 !important',
        display: 'inline-block !important',
        verticalAlign: 'middle !important'
    },
    actions: {
        display: 'none',
        justifyContent: 'flex-start',
        width: '100%',
        alignItems: 'center',
        marginTop: '2%',
        '& button': {
            marginRight: '2.5%',
            textTransform: 'none',
            backgroundColor: theme.palette.primary.main,
            color: 'white',
            '&:hover': {
                backgroundColor: theme.palette.primary.light
            }
        },
        [theme.breakpoints.up(MOBILE)]: {
            display: 'flex'
        }
    },
    practitionerAvatar: {
        width: 47,
        height: 47,
        borderRadius: '50%',
        marginRight: 12,
        objectFit: 'cover'
    },
    anyPractitionerIcon: {
        width: 47,
        height: 47,
        marginRight: 12
    },
    durationContainer: {
        display: 'flex',
        alignItems: 'center',
        margin: '0.35rem 0 0',
        gap: 6
    },
    clockIcon: {
        width: 24,
        height: 24,
        display: 'inline-block !important',
        flexShrink: 0,
        verticalAlign: 'middle !important'
    },
    chevronIcon: {
        width: 6,
        height: 12,
        marginLeft: 16
    }
});

export const aditionalServiceDialogStyles = theme => ({
    button: {
        textTransform: 'none',
        backgroundColor: theme.palette.primary.main,
        color: 'white',
        '&:hover': {
            backgroundColor: theme.palette.primary.light
        },
        margin: '.4rem 1.6rem'
    },
    text: {
        fontSize: '1rem',
        color: theme.palette.black.main,
        textAlign: 'center'
    },
    dialogContent: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        minHeight: '50vh'
    },
    mobileActions: {
        textAlign: 'center'
    }
});
